import { Outlet } from "react-router-dom";

import { FilterVisitProvider } from "./filter-visit/filter-visit.context";
import './visit.scss';

export function Visit() {
  return (
    <div id="ShellVisit" className="visit">
       <FilterVisitProvider>
        <Outlet />
      </FilterVisitProvider>
    </div>
  );
}

export default Visit;
